import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * A class that deals with operation metrics such as the time it takes to
 * perform an operation.
 */
export var OperationMetricsTracker =
/*#__PURE__*/
function () {
  function OperationMetricsTracker() {
    _classCallCheck(this, OperationMetricsTracker);

    this._startTime = null;
    this._endTime = null;
  }
  /**
   * Create a new OperationMetricsTracker.
   *
   * @returns OperationMetricsTracker
   */


  _createClass(OperationMetricsTracker, [{
    key: "start",

    /**
     * Start a time measurement.
     */
    value: function start() {
      if (this._startTime !== null) {
        throw new Error('Measurement is already in progress.');
      }

      this._startTime = Date.now();
    }
    /**
     * End a time measurement.
     */

  }, {
    key: "end",
    value: function end() {
      if (this._startTime === null || this._endTime !== null) {
        throw new Error('Measurement is not in progress.');
      }

      this._endTime = Date.now();
    }
    /**
     * Get the resulting metrics after a measurement has ended.
     *
     * @returns Formatted metrics.
     */

  }, {
    key: "getMetrics",
    value: function getMetrics() {
      if (this._startTime === null || this._endTime === null) {
        throw new Error('Measurement is not done.');
      }

      return {
        start_time: this._startTime,
        end_time: this._endTime
      };
    }
  }], [{
    key: "create",
    value: function create() {
      return new OperationMetricsTracker();
    }
  }]);

  return OperationMetricsTracker;
}();